export { default } from 'mineral-ui/Text';
